import React, { useState, useEffect, useMemo, useRef, useCallback } from "react";
import CaseReview from "./CaseReview";
import { usePersistedDataStore, useLocalDataStore, useCompStore,} from "../store";
import SummaryCaseReviewTable from "./SummaryCaseTable/SummaryCaseReviewTableRefactored";
import EvidenceComparisonTable from "./EvidenceComparisonTable/EvidenceComparisonTable";
import _ from "lodash";
import cloneDeep from 'lodash/cloneDeep';
import { processCompRow } from '../../common/useStreamProcessorNew';
import { useCompLookups } from '../../common/useCompLookups';
import {Navigate} from 'react-router-dom';
import MarketingTable from "./Marketing/MarketingTable";
import DataAnalysisDatagrid from "./DataAnalysis/DataAnalysisDatagrid.js";
import axiosInstance from '../../fetchConfig/axiosConfig';
import { isEqual } from 'lodash';
import { checkCompErrors } from '../../utils/compErrorFlagging';
import { getBadDataParams } from '../../common/mappings.js';
import DialogContentText from '@mui/material/DialogContentText';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import StableMuiDialog from '../../common/StableMuiDialog.js';
import logger from '../../utils/logger';
import { findCompIndex, getExistingCompIds } from './common/compSheetLookup.js';
import { useSelectInventorySale } from './useSelectInventorySale.js';

// Moved inside component scope for better performance

// Should be changed so you don't memoize at the COMP level, memoize whole object (once done) and pass down.
// your stream + state updating re-rendering THIS is probably wrong, if possible to do at lower level
// perhaps, you can abstract some of this to params to enable memoization of this component w/ the base level objects?
// this is a future round of optimizations - I think you can pre-process the majority of this and have the rows etc. ready to rock for each comp incrementation.

// This has gotten unweidly, and should be broken apart, and parameterized instead of all this global state.
function IndividualAnalysisContainer({globalCompRef, compStreamObject}) {
  // Note: Worker is only initialized once (useEffect with empty deps), so re-renders don't recreate it
  const getNegotiationObj = usePersistedDataStore((state) => state.negotiationObj);
  // console.log('getNegotiationObj', getNegotiationObj)
  const setAdjustments = useCompStore((state) => state.setAdjustments);
  const getReviewPage = useLocalDataStore((state) => state.reviewPage);
  const getIsFetching = usePersistedDataStore((state) => state.isFetching);
  const loadingModal = usePersistedDataStore((state) => state.loadingModal);
  const getCompSheet = usePersistedDataStore((state) => state.compSheet);
  const getOptimizedComps = usePersistedDataStore((state) => state.optimizedComps);
  const setCompSheet = usePersistedDataStore((state) => state.setCompSheet);
  const setOptimizedComps = usePersistedDataStore((state) => state.setOptimizedComps);
  const getFilterIndexes = usePersistedDataStore((state) => state.filterIndexes);
  const setFilterIndexes = usePersistedDataStore((state) => state.setFilterIndexes);
  const [updatedArray, setUpdatedArray] = useState([]);
  const queryParams = new URLSearchParams(window.location.search);
  // const comp = useMemo(() => ( parseInt(queryParams.get('comp')) - 1 || 0), [queryParams]);
  const dataAnalysisResult = usePersistedDataStore((state) => state.dataAnalysisResult);
  const dataAnalysisColumns = usePersistedDataStore((state) => state.dataAnalysisColumns);
  const dataAnalysisFilterModel = usePersistedDataStore((state) => state.dataAnalysisFilterModel);
  // Memoized county-specific bad data flags
  // logger.log('getNegotiationObj', getNegotiationObj)
  const countySpecificBadDataFlags = useMemo(() => {
    if (!getNegotiationObj?.MuniCode) return null;
    

    // stupid frontend mapping instead of DB driven lookup for these fields. To revisit eventually.
    const countySpecificParams = getBadDataParams(getNegotiationObj.MuniCode);
    
    return countySpecificParams;
  }, [getNegotiationObj?.MuniCode]);

  
  // Initialize comp lookups for handling missing comps
  const compLookups = useCompLookups({ maxConcurrent: 8, batchThreshold: 15, maxWaitTime: 1000 });

  // this is setting the value, but the negotiation state isnt there yet (i think)
  const memoizedOptimizedComps = useMemo(() => getOptimizedComps, [getOptimizedComps]);
  const memoizedCompSheet = useMemo(() => getCompSheet, [getCompSheet]);
  const memoizedNegotiationObj = useMemo(() => getNegotiationObj.cases, [getNegotiationObj.cases]);

  const { pickSale, dialog: inventorySaleDialog } = useSelectInventorySale();

  // if the user is adding a comp which doesn't exist, update your state to reflect that.  
  // Here - we are going to update this function so that it performs CHECKS on the PID (ie: exists in regular, not in optimize, or neither)
  // other checks are for NAL sale
  //  and salecondition issue
  
  const addCompNotInResponseCallback = useCallback(
    async (parcel_id, comp) => {
      if (!parcel_id) return null;

      const currentCompSheet = getCompSheet[comp];
      const reportType = getNegotiationObj.reportType || usePersistedDataStore.getState().reportType;
      const isSaleRun = String(reportType || '').toLowerCase() !== 'assessment';

      // Assessment identity is parcel_id; skip lookup if that parcel is already on the sheet.
      if (!isSaleRun && currentCompSheet?.parcel_id?.includes(parcel_id)) {
        return {
          exists: true,
          parcel_id: parcel_id,
          message: 'Comp already exists in comp sheet'
        };
      }

      // axios post to lookup_property_inventory
      const response = await axiosInstance.post('/lookup_property_inventory', { parcel_id, year: getNegotiationObj.TaxYear });
      logger.log('lookup response', response);
      const rowData = await pickSale(response.data, isSaleRun);
      if (!rowData) return null;

      const identityId = isSaleRun
        ? (rowData.TransactionID != null && rowData.TransactionID !== '' ? rowData.TransactionID : parcel_id)
        : parcel_id;
      if (findCompIndex(currentCompSheet, identityId, reportType) >= 0) {
        return {
          exists: true,
          parcel_id,
          TransactionID: rowData.TransactionID,
          message: 'Comp already exists in comp sheet'
        };
      }

      // Get subject values for price adjustments
      const subjectValues = {};
      if (currentCompSheet) {
        Object.entries(currentCompSheet).forEach(([key, value]) => {
          if (Array.isArray(value) && value.length > 0) {
            subjectValues[key] = value[0];
          }
        });
      }
      logger.log('rowData', rowData) 

      // Create copies of the current comp objects
      const updatedCompSheet = [...getCompSheet];
      const updatedOptimizedComps = [...getOptimizedComps];
      
      const oldCompObject = updatedCompSheet[comp] || {};
      const oldOptimizedObject = updatedOptimizedComps[comp] || {};

      // Create shallow copies of comp objects to preserve array structure
      // We need to preserve the original array structure for proper insertion
      const newCompObject = { ...oldCompObject };
      const newOptimizedObject = { ...oldOptimizedObject };

      // Use the unified function to process the comp and insert at index 1
      // Pass adjustments to ensure adj_price is calculated
      processCompRow(rowData, newCompObject, getNegotiationObj, subjectValues, 1);
      processCompRow(rowData, newOptimizedObject, getNegotiationObj, subjectValues, 1);

      // Update the state
      updatedCompSheet[comp] = newCompObject;
      updatedOptimizedComps[comp] = newOptimizedObject;
      
      setCompSheet(updatedCompSheet);
      setOptimizedComps(updatedOptimizedComps);

      // Track manually added comps -- what is this used for again? lol. check adjustmetn calculator func.
      const currentAdjustments = useCompStore.getState().adjustments;
      const updatedAdjustments = {
        ...currentAdjustments,
        manuallyAddedComps: {
          ...(currentAdjustments.manuallyAddedComps || {}),
          [identityId]: true
        }
      }
      setAdjustments(updatedAdjustments);

      // Add error checking to the row data
      const getAdjustments = useCompStore.getState().adjustments;
      const getReportType = usePersistedDataStore.getState().reportType;
      const isAssessmentRun = getReportType.toLowerCase() === 'assessment';
      const errorResult = checkCompErrors(rowData, subjectValues, {}, getAdjustments, isAssessmentRun);
      if (errorResult.errorCodes.length > 0) {
        rowData.errors = errorResult.errorCodes;
        rowData.errorMessages = errorResult.errorMessages;
      }

      return rowData;
    },
    [getCompSheet, getOptimizedComps, getNegotiationObj, setAdjustments, setCompSheet, setOptimizedComps, pickSale]
  );
    // Use the stream processor with our callback

    // WHEN YOU RENDER THE COMPGRID - DO NOT HAVE THE NEGOTIATION OBJ IN THE DEPENDENCY ARRAY
    // Don't create re-renders when the casenotes (or offer) are updated.
      const lastFilterRef = useRef(null);
      const lastSeenUpdatedCountRef = useRef(0);
      const pendingMergeIndicesRef = useRef(new Set());
      const lastGlobalMergeLenRef = useRef(0);
      // const [filterType, setFilterType] = useState('all'); // State for the selected filter

    // Model fetching is now handled by CaseAnalysisContainer via invokeModels
    // No need to trigger KNN fetch here anymore

    // I think this filtering has become irrelevant in the new version.
      const filterIndexes = useCallback((type) => {
      if (type === 'all') {
      // If the filter type is "all", set the filter indexes to undefined
      setFilterIndexes(undefined);
      lastFilterRef.current = undefined;
      return undefined;
      }

      const cases = cloneDeep(getNegotiationObj.cases);

      // Create an array of indexes that meet the criteria
      const indexesToKeep = cases.reduce((indexes, currentCase, index) => {
      let keep = false;

      if (type === 'open') { // "unsettled"
          const scarStageExists = cases.some(c => c.SCARFiled === 1);
          if (scarStageExists) {
              keep = !['S', 'SD', 'ST', 'W', 'NM', 'AH'].includes(currentCase.SCARDeterminationAction) && currentCase.SCARFiled === 1;
          } else {
              keep = !['S', 'SD', 'ST', 'W', 'NM', 'AH'].includes(currentCase.SCARDeterminationAction);
          }
      } else if (type === 'settled') {
          keep = ['S', 'SD', 'ST', 'W', 'NM', 'AH'].includes(currentCase.SCARDeterminationAction);
      } else if (type === 'unreviewed') {
          // Redo this, it should only be kept if Object.keys(currentCase.Comps).length>0
          logger.log(currentCase)
          keep = !currentCase.Comps || (typeof currentCase.Comps === 'object' && Object.keys(currentCase.Comps).length === 0);
      // } else if (type === 'noMarketValue') {

          // keep = !currentCase.SubjectMarketValue;
      } else if (type === 'scar') {
          keep = currentCase.RepID !== "" && currentCase.RepID != null || currentCase.SCARFiled === 1;
      }

      // Add index to the array if it meets the criteria
      if (keep) {
          indexes.push(index);
      }

      return indexes;
      }, []);

      if (_.isEqual(indexesToKeep, lastFilterRef.current)) {
      return indexesToKeep;
      }

      setFilterIndexes(indexesToKeep);
      lastFilterRef.current = indexesToKeep;

      return indexesToKeep; // or use it as needed
      }, [getNegotiationObj.cases]);

      // Reset the array which tracks the updated state of differnt cases (for inventory updates)
      const resetUpdateArrayCallback = useCallback((length) => {
        // Assuming filteredCompSheet is accessible in this scope
        logger.log('resetting updated array')
        logger.log(new Array(length).fill(false))
        setUpdatedArray(new Array(length).fill(false));
      }, []);
      

      // Function is slightly more performant now that we switched to worker, but for sure still redundant iterations.
      const handleUpdateStateCallback = useCallback((removeNALSales = false) => {
        // Check if we're in negotiation view - if so, skip this logic as it doesn't apply
        if (getNegotiationObj.reportType === 'negotiation') {
          return;
        }

        const currentUpdatedCount =
          compStreamObject?.current?.updated?.filter(Boolean).length ?? 0;
        const casesLen = getNegotiationObj.cases.length || 0;
        const globalStreamArr = globalCompRef.current?.properties?.[0];
        // NOTE: globalCompRef.current.properties[0] is often pre-sized/padded with nulls.
        // Using `.length` here makes it look like we've "progressed" to casesLen immediately.
        // We want the count of non-null streamed entries.
        let globalStreamNonNullCount = 0;
        if (Array.isArray(globalStreamArr)) {
          for (let i = 0; i < globalStreamArr.length; i += 1) {
            if (globalStreamArr[i]) globalStreamNonNullCount += 1;
          }
        }
        const progressed = Math.max(currentUpdatedCount, globalStreamNonNullCount);
        const remaining = Math.max(0, casesLen - progressed);
        const nearingEnd = casesLen > 0 && remaining <= 50;
        const globalHasNewComps =
          globalCompRef.current?.properties[0]?.length > 0 &&
          (globalCompRef.current.properties[0].length >
            getCompSheet.filter(Boolean).length ||
            getNegotiationObj.cases.length < 2);
        const hasPendingBatch = pendingMergeIndicesRef.current.size > 0;

        if (
          !globalHasNewComps &&
          currentUpdatedCount === lastSeenUpdatedCountRef.current &&
          !hasPendingBatch
        ) {
          return;
        }
        lastSeenUpdatedCountRef.current = currentUpdatedCount;
        
        // Check if we have more comps from the stream processing
        const filteredCompSheet = getCompSheet.filter(item => item !== null && item !== undefined);
        // updated to include when less than 2 cases (ie: one case, it has to trigger this to fetch)
        // Also added a guard for the response being non empty.
        const globalHasMoreComps = globalCompRef.current?.properties[0]?.length > 0 && (globalCompRef.current?.properties[0]?.length > filteredCompSheet.length || getNegotiationObj.cases.length <2);
        const anyIsUpdatedFalse = ((Array.isArray(compStreamObject.current?.updated) && compStreamObject.current.updated.some(isUpdated => isUpdated)) || updatedArray.some(isUpdated => !isUpdated)) || false
        // Comp lookup: enqueue missing saved comps when we have stream updates (either global or compStreamObject-driven)
        const shouldRunCompLookup = (anyIsUpdatedFalse || globalHasMoreComps);
        if (shouldRunCompLookup) {
          const currentNegotiationObj = usePersistedDataStore.getState().negotiationObj;
          const ref = globalHasMoreComps ? globalCompRef.current : compStreamObject.current;
          const regularCompsByCase = ref?.properties?.[0];
          if (ref && regularCompsByCase) {
            regularCompsByCase.forEach((regularComp, index) => {
              if (regularComp?.parcel_id && currentNegotiationObj?.cases?.[index]?.Comps) {
                const reportType = currentNegotiationObj.reportType || 'standard';
                compLookups.enqueueMissingSavedComps({
                  savedCompIds: Object.values(currentNegotiationObj.cases[index].Comps || {}),
                  existingCompIds: getExistingCompIds(regularComp, reportType),
                  taxYear: currentNegotiationObj.TaxYear,
                  ref,
                  caseIndex: index,
                  negotiationObj: currentNegotiationObj,
                  panes: [0, 1],
                  reportType,
                });
              }
            });
          }
        }

        // Don't create new array references unless necessary
        let regularCompsToUpdate = getCompSheet;
        let optimizedCompsToUpdate = getOptimizedComps;
        let updatedArrayNewRef = updatedArray;

        if (globalHasMoreComps) {
          const newRegularComps = globalCompRef.current.properties[0].filter(comp => comp !== null);
          const newOptimizedComps = globalCompRef.current.properties[1].filter(comp => comp !== null);
          const shouldBatch = casesLen > 1000 && !nearingEnd;
          if (shouldBatch) {
            const delta = newRegularComps.length - (lastGlobalMergeLenRef.current || 0);
            if (delta < 10) {
            } else {
              if (!isEqual(newRegularComps, getCompSheet)) setCompSheet(newRegularComps);
              if (!isEqual(newOptimizedComps, getOptimizedComps)) setOptimizedComps(newOptimizedComps);
              lastGlobalMergeLenRef.current = newRegularComps.length;
            }
          } else {
            if (!isEqual(newRegularComps, getCompSheet)) setCompSheet(newRegularComps);
            if (!isEqual(newOptimizedComps, getOptimizedComps)) setOptimizedComps(newOptimizedComps);
            lastGlobalMergeLenRef.current = newRegularComps.length;
          }
        }

        // When cases.length < 2, globalHasMoreComps is often true (left side of the OR) even though
        // inventory-KNN data only lands in compStreamObject — the old (any && !global) check skipped
        // merging compStream into Zustand entirely, so handleUpdateStateCallback "ran" with no setCompSheet.
        const compStreamHasPendingMerge =
          Array.isArray(compStreamObject.current?.updated) &&
          compStreamObject.current.updated.some(
            (val, i) => val === true && updatedArray[i] === false
          );

        if (anyIsUpdatedFalse && (!globalHasMoreComps || compStreamHasPendingMerge)) {
          let hasChanges = false;
          const updatedIndices = new Set();

          getCompSheet.forEach((_, index) => {
            if (
              compStreamObject.current.properties.length > 0 &&
              updatedArray[index] === false &&
              compStreamObject.current.updated[index] === true
            ) {
              const newRegularComp = compStreamObject.current.properties[0][index];
              const newOptimizedComp = compStreamObject.current.properties[1][index];
              if (!isEqual(getCompSheet[index], newRegularComp)) hasChanges = true;
              if (!isEqual(getOptimizedComps[index], newOptimizedComp)) hasChanges = true;
              updatedIndices.add(index);
            }
          });

          if (!hasChanges && updatedIndices.size === 0) {
            return;
          }

          const shouldBatch = casesLen > 1000 && !nearingEnd;
          let indicesToFlush = Array.from(updatedIndices);
          if (shouldBatch) {
            updatedIndices.forEach((i) => pendingMergeIndicesRef.current.add(i));
            if (pendingMergeIndicesRef.current.size < 10) {
              return;
            }

            indicesToFlush = Array.from(pendingMergeIndicesRef.current).slice(0, 10);
            indicesToFlush.forEach((i) => pendingMergeIndicesRef.current.delete(i));
          } else if (casesLen > 1000 && nearingEnd && pendingMergeIndicesRef.current.size > 0) {
            const buffered = Array.from(pendingMergeIndicesRef.current);
            pendingMergeIndicesRef.current.clear();
            indicesToFlush = Array.from(new Set([...buffered, ...indicesToFlush]));
          }

          regularCompsToUpdate = [...getCompSheet];
          optimizedCompsToUpdate = [...getOptimizedComps];
          updatedArrayNewRef = [...updatedArray];

          indicesToFlush.forEach((index) => {
            regularCompsToUpdate[index] = compStreamObject.current.properties[0][index];
            optimizedCompsToUpdate[index] = compStreamObject.current.properties[1][index];
            updatedArrayNewRef[index] = true;
          });

          setUpdatedArray(updatedArrayNewRef);
          setCompSheet(regularCompsToUpdate);
          setOptimizedComps(optimizedCompsToUpdate);

          // if (getReviewPage && getFilterIndexes) filterIndexes(filterType);
        } else {
          // if (getReviewPage && getFilterIndexes) {
          //   filterIndexes(filterType);
          // }
          return true;
        }
      }, [getCompSheet, getOptimizedComps, updatedArray, 
        // filterType,
        //  filterIndexes,
        // getFilterIndexes,
        //  getReviewPage,
        getNegotiationObj.reportType, getNegotiationObj.cases.length]);
      
      // logger.log('getcompsheet', Object.keys(getCompSheet[0]))
      const savedCallbackRef = useRef(handleUpdateStateCallback);
    
      // dumb, ugly methodology to keep the ref current as the function rerenders. forget why I even needed to do this (am sure it had to do with stale function refs, probably w/ the interval)
      useEffect(() => {
        savedCallbackRef.current = handleUpdateStateCallback;
      }, [handleUpdateStateCallback]);



    if(getCompSheet==='' && (getNegotiationObj.reportType !== 'marketing' || getNegotiationObj.reportType !== 'data_analysis')){
      logger.log('navigating to analysis')
      return <Navigate to={`/analysis?${queryParams}`} />
    }



  return (
    <div className="bg-gray-200 flex flex-col h-full min-h-0">
      {inventorySaleDialog}
      <StableMuiDialog open={!!loadingModal} disableEscapeKeyDown PaperProps={{ sx: { p: 3, minWidth: 280 } }}>
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2 }}>
          <CircularProgress size={40} />
          <DialogContentText>{loadingModal?.label || 'Loading...'}</DialogContentText>
          {loadingModal?.totalSteps != null && loadingModal.totalSteps > 0 && (
            <DialogContentText variant="body2" color="text.secondary">
              Step {loadingModal.currentStep} of {loadingModal.totalSteps}
            </DialogContentText>
          )}
        </Box>
      </StableMuiDialog>
      <div className="h-full overflow-y-hidden flex-1 min-h-0 flex flex-col">
          <section className="overflow-y-hidden max-w-screen-22xl px-6 pb-5 h-full flex flex-col min-h-0 flex-1 box-border" id='home'>
            <>
            {getNegotiationObj.reportType === 'marketing' ?
              <MarketingTable 
                MuniCode={getNegotiationObj.MuniCode}
                countyString={getNegotiationObj.countyString}
                muniString={getNegotiationObj.muniString}
                TaxYear={getNegotiationObj.TaxYear}
              />
            :
            getNegotiationObj.reportType === 'data_analysis' ? (
              <div className='mt-2'>
                <DataAnalysisDatagrid
                  columns={dataAnalysisColumns}
                  rows={dataAnalysisResult}
                  initialFilterModel={dataAnalysisFilterModel}
                  headerText="Data Cleaning Report"
                  isUpdating={getIsFetching}
                  totalRows={getNegotiationObj.totalRows}
                  clientCount={getNegotiationObj.clientCount}
                  countySpecificBadDataFlags={countySpecificBadDataFlags}
                />
              </div>
            ) :
            getNegotiationObj.reportType === 'evidence_comparison' ? (
              <EvidenceComparisonTable
                negotiationCases={getNegotiationObj.cases}
              />
            ) :
            getReviewPage ?
            <>
            <SummaryCaseReviewTable
              negotiationCases={getNegotiationObj.cases}
              filteredNegotiationCases={getNegotiationObj.cases}
              handleUpdateStateCallback={handleUpdateStateCallback}
            />
            </>
            :
            // Here you can render the case review object
            // This is not going to be optimized the way it should be
            // I would like this top level to:
            // hold the higher level negotiation object
            // You need the below container to be the only thing that updates on comp change, 
              <CaseReview 
                addCompNotInResponseCallback={addCompNotInResponseCallback}
                originalCompObject={memoizedCompSheet}
                originalCaseObject={memoizedNegotiationObj}
                originalOptimizedObject={memoizedOptimizedComps}
                runParameters={{
                  MuniCode: getNegotiationObj.MuniCode,
                  TaxYear: getNegotiationObj.TaxYear,
                  reportType: getNegotiationObj.reportType,
                  countyString: getNegotiationObj.countyString,
                  muniString: getNegotiationObj.muniString,
                  earliestCutoffDate: getNegotiationObj.earliestCutoffDate,
                  latestCutoffDate: getNegotiationObj.latestCutoffDate,
                  CourtRun: getNegotiationObj.CourtRun,
                  showSettledCases: getNegotiationObj.showSettledCases,
                  manualReview: getNegotiationObj.manualReview,
                  mlsCompsOnly: getNegotiationObj.mlsCompsOnly,
                  allowConditionIssues: getNegotiationObj.allowConditionIssues,
                  villageRun: getNegotiationObj.villageRun,
                  TrainingUser: getNegotiationObj.TrainingUser,
                  UserId: getNegotiationObj.UserId,
                  manualReviewOverride: getNegotiationObj.manualReviewOverride,
                  scarOnly: getNegotiationObj.scarOnly,
                  reviewedCasesFlag: getNegotiationObj.reviewedCasesFlag,
                  RepId: getNegotiationObj.RepId,
                }}
                updatedArray={updatedArray}
                handleUpdateStateCallback={handleUpdateStateCallback}              
                savedCallbackRef={savedCallbackRef}
                compStreamObject={compStreamObject}
                resetUpdateArrayCallback={resetUpdateArrayCallback}
                >
              </CaseReview>
              // null
            }
            </>
          </section>
        </div>
      </div>
    );
  }
  React.memo(IndividualAnalysisContainer);
  IndividualAnalysisContainer.WhyDidYouRender = true;
  export default IndividualAnalysisContainer;
